<template>
  <v-os-popup
    class="popup-receipt"
    title="收款方式"
    v-model="show"
    @close="close"
    container="body"
    @footerClick="confirm"
    :footerShow="true"
    :class="{ 'custom-dark': customDark }"
  >
    <div class="item name">
      <nx-input-item
        :ariaFieldFocus="{ all: true }"
        :ariaLabelContent="{ all: '输入框，真实姓名' }"
        title="真实姓名"
        v-model="name"
        placeholder="请填写支付宝真实姓名"
      ></nx-input-item>
    </div>
    <div class="item phone">
      <nx-input-item
        title="支付宝账号"
        :ariaFieldFocus="{ all: true }"
        :ariaLabelContent="{ all: '输入框，支付宝账号' }"
        v-model="account"
        placeholder="请填写支付宝账号"
      ></nx-input-item>
    </div>
  </v-os-popup>
</template>
<script>
import { InputItem } from '@vivo/vos-ui'

export default {
  name: 'PayMethodPopUp',
  components: {
    [InputItem.name]: InputItem
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          isShow: false,
          name: '',
          account: ''
        }
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    customDark: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: '',
      account: ''
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.name = this.info.name
        this.account = this.info.account
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    confirm() {
      if (!this.name) {
        this.$toast('请填写真实姓名')
        return
      }
      if (!this.account) {
        this.$toast('请填写支付宝账号')
        return
      }
      this.$emit('save', {
        name: this.name,
        account: this.account
      })
      this.$emit('close')
    }
  },
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.vivo-fontscale-4 .item {
  ::v-deep .nx-field-item__left {
    .nx-field-item__title {
      font-size: 42px;
    }
  }
}
.item {
  .nx-input-item {
    padding: 0;
  }
  &::v-deep .nx-field-item__container {
    padding: 0 0 48px 0;
    min-height: 108px;
  }
  ::v-deep .nx-field-item__left {
    width: 250px;
    .nx-field-item__title {
      font-size: 45px;
      @include os-font-weight(45, 50);
    }
  }
  ::v-deep .nx-field-item__middle {
    background: #f9f9f9;
    height: 108px;
    border-radius: 36px;
    padding: 0 30px;
    input {
      padding: 0;
    }
  }
  width: 100%;
}
.popup-receipt.custom-dark {
  ::v-deep .nx-field-item__middle {
    @include bgColor(#f9f9f9, rgba(255, 255, 255, 0.1));
  }

  ::v-deep .v-os-popup__footer {
    @media (prefers-color-scheme: dark) {
      background-color: $dark_bg_color !important;
      border-color: rgba(255, 255, 255, 0.15) !important;
      .v-button--plain {
        background: $dark_bg_color !important;
      }
    }
  }
}
</style>
